'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.withSlideContext = exports.SlideContext = exports.withCarousel = exports.inRange = exports.CarouselSubscriber = exports.ChangeSlideButton = exports.SlideContainer = exports.Carousel = exports.ThemedCarousel = undefined;

var _themeProvider = require('@spp/theme-provider');

var _Carousel = require('./Carousel');

var _Carousel2 = _interopRequireDefault(_Carousel);

var _SlideContainer = require('./SlideContainer');

var _SlideContainer2 = _interopRequireDefault(_SlideContainer);

var _ChangeSlideButton = require('./ChangeSlideButton');

var _ChangeSlideButton2 = _interopRequireDefault(_ChangeSlideButton);

var _util = require('./util');

var _withCarousel = require('./with-carousel');

var _withSlideContext = require('./with-slide-context');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemedCarousel = (0, _themeProvider.themer)('@spp/ui-carousel')(_Carousel2.default);

exports.ThemedCarousel = ThemedCarousel;
exports.Carousel = _Carousel2.default;
exports.SlideContainer = _SlideContainer2.default;
exports.ChangeSlideButton = _ChangeSlideButton2.default;
exports.CarouselSubscriber = _withCarousel.CarouselSubscriber;
exports.inRange = _util.inRange;
exports.withCarousel = _withCarousel.withCarousel;
exports.SlideContext = _withSlideContext.SlideContext;
exports.withSlideContext = _withSlideContext.withSlideContext;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-carousel/lib/cjs/index.js
 ** module id = 287
 ** module chunks = 1
 **/